import React from 'react'

import { Button } from '@insquad/tools'

import { BannerAnimation } from 'src/common/animations/BannerAnimation/BannerAnimation'
import {
  Typography,
  EnumTypographyVariants,
} from 'src/common/components/Typography/Typography'
import { useAuthRedirect } from 'src/common/hooks/useAuthRedirect'
import { AnalyticEventEnum } from 'src/utils/analytic/analyticEventEnum'
import { useAnalytic } from 'src/utils/analytic/useAnalytic'

import { LoginBannerIcon } from './LoginBannerIcon'

import s from './ResumeLoginBanner.module.scss'

export interface IResumeLoginBannerProps {
  resumeId: string
}

export const ResumeLoginBanner: React.FC<IResumeLoginBannerProps> = ({
  resumeId,
}) => {
  const { analytic } = useAnalytic()
  const { handleSignUpRedirect } = useAuthRedirect()

  const handleSignUp = () => {
    analytic.event(AnalyticEventEnum.SIGN_UP, {
      page: 'profile',
      from: 'footer',
    })

    const additionalQuery = `resume-id=${resumeId}`
    handleSignUpRedirect(additionalQuery)
  }

  return (
    <BannerAnimation
      isVisible
      rootProps={{
        className: s.ResumeLoginBanner,
      }}
    >
      <div className={s.ResumeLoginBanner__content}>
        <Typography
          variant={EnumTypographyVariants.H3F}
          text="Would you like to schedule an interview with this candidate?"
        />

        <Typography
          variant={EnumTypographyVariants.P1F}
          text="Register in our service and hire qualified developers from all over the world!"
          className={s.ResumeLoginBanner__description}
        />

        <Button onClick={handleSignUp} className={s.ResumeLoginBanner__btn}>
          Sign up
        </Button>
      </div>

      <div className={s.ResumeLoginBanner__icon}>
        <LoginBannerIcon />
      </div>
    </BannerAnimation>
  )
}
